export default {
    testTitle: '',
    testContent: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js